import { render, staticRenderFns } from "./CreateStoreMovementView.vue?vue&type=template&id=6256d29c&scoped=true&"
import script from "./CreateStoreMovementView.vue?vue&type=script&lang=ts&"
export * from "./CreateStoreMovementView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6256d29c",
  null
  
)

export default component.exports